import type {
  ConvertContextPathProps,
  ConvertContextRouteProps,
} from "./organization-context.type";

import { generatePath, matchPath } from "react-router";

export const convertContextRoute = ({
  pathname,
  route,
  newRoute,
  context,
}: ConvertContextRouteProps) => {
  const match = matchPath({ path: route, end: true }, pathname); // exact match only
  const params = { ...match?.params, context };

  return generatePath(newRoute ?? route, params);
};

/**
 * Computes the target path after a context switch.
 *
 * - For context-scoped routes (`/org/:context/...`): replaces the context slug.
 * - Exception: detail pages (`/org/:context/:section/:id`) redirect to the list hub,
 *   since the item may not exist in the new context.
 * - Non-context routes (`/admin/...`, `/preferences`, etc.) are `undefined`.
 */
export const convertContextPath = ({
  pathname,
  context,
}: ConvertContextPathProps): string | undefined => {
  /** 1. Section routes with context AND with or without `:id` */

  const sectionRoute = "/org/:context/:section";
  const sectionMatch = matchPath({ path: sectionRoute, end: false }, pathname); // prefix match

  if (sectionMatch) {
    const section = sectionMatch.params.section ?? "";
    return generatePath(sectionRoute, { context, section });
  }

  /** 2. Home route with context */

  const homeRoute = "/org/:context";
  const matchHome = matchPath(homeRoute, pathname); // exact match only

  if (matchHome) {
    return generatePath(homeRoute, { context });
  }

  /** 3. Non-context routes */

  return undefined;
};
